<template>
  <div class="app-container">
    <el-tabs v-model="activeModule" @tab-click="onModuleTab">
      <el-tab-pane label="流转管理" name="flow"></el-tab-pane>
      <el-tab-pane label="分拣管理" name="sorting"></el-tab-pane>
      <el-tab-pane label="车辆驿站" name="vehicle"></el-tab-pane>
      <el-tab-pane label="仓库管理" name="warehouse"></el-tab-pane>
      <el-tab-pane label="中转站" name="transfer"></el-tab-pane>
    </el-tabs>

    <div v-if="activeModule==='flow'">
      <el-tabs v-model="flowTab" @tab-click="fetchFlow">
        <el-tab-pane label="待清拣" name="pending"></el-tab-pane>
        <el-tab-pane label="转运中" name="moving"></el-tab-pane>
        <el-tab-pane label="待入库" name="to_store"></el-tab-pane>
      </el-tabs>
      <div class="data-table">
        <el-table :data="flowData" border>
          <el-table-column prop="trace_no" label="流转编号"></el-table-column>
          <el-table-column prop="start_time" label="流转开始时间" width="160"></el-table-column>
          <el-table-column prop="end_time" label="流转结束时间" width="160"></el-table-column>
          <el-table-column prop="stay_time" label="停留时长" width="120"></el-table-column>
          <el-table-column prop="vehicle" label="流转车辆" width="140"></el-table-column>
          <el-table-column prop="route" label="流转路线" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="location" label="定位" width="140"></el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            @size-change="p => { flowPage.pageSize = p; fetchFlow() }"
            @current-change="p => { flowPage.page = p; fetchFlow() }"
            :current-page="flowPage.page"
            :page-sizes="[10,20,50,100]"
            :page-size="flowPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="flowPage.total">
          </el-pagination>
        </div>
      </div>
    </div>

    <div v-else-if="activeModule==='sorting'">
      <el-tabs v-model="sortingTab" @tab-click="handleCategoryTab">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="纸类" name="paper"></el-tab-pane>
        <el-tab-pane label="金属类" name="metal"></el-tab-pane>
        <el-tab-pane label="家电类" name="appliance"></el-tab-pane>
        <el-tab-pane label="织物类" name="fabric"></el-tab-pane>
        <el-tab-pane label="塑料类" name="plastic"></el-tab-pane>
        <el-tab-pane label="其他" name="other"></el-tab-pane>
      </el-tabs>
      <div class="search-bar">
        <el-form :inline="true" :model="sortingSearch" size="small">
          <el-form-item>
            <el-input v-model="sortingSearch.delivery_unit" placeholder="交货单位" clearable style="width: 160px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="sortingSearch.center_name" placeholder="分拣中心名称" clearable style="width: 160px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="sortingSearch.province_code" placeholder="选择省" clearable style="width: 120px;" @change="onProvinceSelect">
              <el-option v-for="p in provinces" :key="p.code" :label="p.name" :value="p.code" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="sortingSearch.city_code" placeholder="选择市" clearable style="width: 120px;" @change="onCitySelect">
              <el-option v-for="c in cities" :key="c.code" :label="c.name" :value="c.code" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="sortingSearch.area_code" placeholder="选择区" clearable style="width: 120px;" @change="onAreaSelect">
              <el-option v-for="a in areas" :key="a.code" :label="a.name" :value="a.code" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="sortingSearch.street_code" placeholder="选择街道" clearable style="width: 120px;">
              <el-option v-for="s in streets" :key="s.code" :label="s.name" :value="s.code" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="sortingSearch.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 240px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetSorting">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="data-table">
        <el-table :data="sortingData" border>
          <el-table-column prop="delivery_unit" label="交货单位" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="center_name" label="分拣中心" width="160"></el-table-column>
          <el-table-column label="交货图片" width="120" align="center">
            <template slot-scope="scope">
              <el-image 
                style="width: 50px; height: 50px"
                :src="scope.row.image_url" 
                :preview-src-list="[scope.row.image_url]"
                v-if="scope.row.image_url">
              </el-image>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="delivery_time" label="交货时间" width="160"></el-table-column>
          <el-table-column prop="delivery_person_name" label="交货人" width="120"></el-table-column>
          <el-table-column prop="warehouse_keeper_name" label="库管人员" width="120"></el-table-column>
          <el-table-column prop="category_name" label="交货品类" width="120"></el-table-column>
          <el-table-column prop="weight" label="交货重量(kg)" width="140"></el-table-column>
          <el-table-column prop="plate_no" label="车牌号" width="140"></el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            @size-change="p => { sortingPage.pageSize = p; fetchSorting() }"
            @current-change="p => { sortingPage.page = p; fetchSorting() }"
            :current-page="sortingPage.page"
            :page-sizes="[10,20,50,100]"
            :page-size="sortingPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="sortingPage.total">
          </el-pagination>
        </div>
      </div>
    </div>

    <div v-else-if="activeModule==='vehicle'">
      <div class="toolbar">
        <el-button type="primary">新增车辆驿站</el-button>
      </div>
      <div class="data-table">
        <el-table :data="vehicleData" border>
          <el-table-column prop="plate_no" label="车牌号" width="140"></el-table-column>
          <el-table-column prop="manager" label="负责人" width="140"></el-table-column>
          <el-table-column prop="info" label="车辆信息" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column prop="created_at" label="创建时间" width="160"></el-table-column>
          <el-table-column label="操作" width="160" fixed="right">
            <template>
              <el-button type="text" size="small">编辑</el-button>
              <el-button type="text" size="small" style="color: #F56C6C">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            @size-change="p => { vehiclePage.pageSize = p }"
            @current-change="p => { vehiclePage.page = p }"
            :current-page="vehiclePage.page"
            :page-sizes="[10,20,50,100]"
            :page-size="vehiclePage.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="vehiclePage.total">
          </el-pagination>
        </div>
      </div>
    </div>

    <div v-else-if="activeModule==='warehouse'">
      <div class="toolbar">
        <el-button type="primary">新增仓库</el-button>
      </div>
      <div class="data-table">
        <el-table :data="warehouseData" border>
          <el-table-column prop="name" label="仓库名称" min-width="160"></el-table-column>
          <el-table-column prop="code" label="仓库编号" width="160"></el-table-column>
          <el-table-column prop="address" label="地址" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="location" label="经纬度" width="160"></el-table-column>
          <el-table-column prop="status" label="状态" width="120"></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="160" fixed="right">
            <template>
              <el-button type="text" size="small">编辑</el-button>
              <el-button type="text" size="small" style="color: #F56C6C">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            @size-change="p => { warehousePage.pageSize = p }"
            @current-change="p => { warehousePage.page = p }"
            :current-page="warehousePage.page"
            :page-sizes="[10,20,50,100]"
            :page-size="warehousePage.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="warehousePage.total">
          </el-pagination>
        </div>
      </div>
    </div>

    <div v-else-if="activeModule==='transfer'">
      <div class="toolbar">
        <el-button type="primary">新增中转站</el-button>
      </div>
      <div class="data-table">
        <el-table :data="transferData" border>
          <el-table-column prop="name" label="中转站名称" min-width="160"></el-table-column>
          <el-table-column prop="code" label="中转站编号" width="160"></el-table-column>
          <el-table-column prop="circle" label="环保圈" width="120"></el-table-column>
          <el-table-column prop="address" label="地址" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="location" label="经纬度" width="160"></el-table-column>
          <el-table-column prop="status" label="状态" width="120"></el-table-column>
          <el-table-column prop="total_move" label="总搬数" width="120"></el-table-column>
          <el-table-column prop="empty_count" label="空货数" width="120"></el-table-column>
          <el-table-column prop="full_count" label="满货数" width="120"></el-table-column>
          <el-table-column prop="total_weight" label="总重量(kg)" width="140"></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="160" fixed="right">
            <template>
              <el-button type="text" size="small">编辑</el-button>
              <el-button type="text" size="small" style="color: #F56C6C">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            @size-change="p => { transferPage.pageSize = p }"
            @current-change="p => { transferPage.page = p }"
            :current-page="transferPage.page"
            :page-sizes="[10,20,50,100]"
            :page-size="transferPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="transferPage.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/api/interceptor'
export default {
  name: 'SortingCenter',
  data() {
    return {
      activeModule: 'flow',
      flowTab: 'pending',
      sortingTab: 'all',
      flowData: [],
      sortingData: [],
      vehicleData: [],
      warehouseData: [],
      transferData: [],
      flowPage: { page: 1, pageSize: 10, total: 0 },
      sortingPage: { page: 1, pageSize: 10, total: 0 },
      vehiclePage: { page: 1, pageSize: 10, total: 0 },
      warehousePage: { page: 1, pageSize: 10, total: 0 },
      transferPage: { page: 1, pageSize: 10, total: 0 },
      sortingSearch: {
        delivery_unit: '',
        center_name: '',
        province_code: '',
        city_code: '',
        area_code: '',
        street_code: '',
        dateRange: []
      },
      provinces: [],
      cities: [],
      areas: [],
      streets: []
    }
  },
  created() {
    this.fetchProvinces()
  },
  methods: {
    onModuleTab() {},
    fetchFlow() {},
    fetchSorting() {},
    resetSorting() {
      this.sortingSearch = {
        delivery_unit: '',
        center_name: '',
        province_code: '',
        city_code: '',
        area_code: '',
        street_code: '',
        dateRange: []
      }
      this.cities = []
      this.areas = []
      this.streets = []
      this.sortingPage.page = 1
      this.fetchSorting()
    },
    async fetchProvinces() {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get' })
        const body = res && res.data ? res.data : res
        this.provinces = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
      } catch (e) { this.provinces = [] }
    },
    async fetchCities(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        this.cities = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
      } catch (e) { this.cities = [] }
    },
    async fetchAreas(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        this.areas = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
      } catch (e) { this.areas = [] }
    },
    async fetchStreets(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        this.streets = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
      } catch (e) { this.streets = [] }
    },
    onProvinceSelect(code) {
      this.sortingSearch.city_code = ''
      this.sortingSearch.area_code = ''
      this.sortingSearch.street_code = ''
      this.cities = []
      this.areas = []
      this.streets = []
      if (code) this.fetchCities(code)
    },
    onCitySelect(code) {
      this.sortingSearch.area_code = ''
      this.sortingSearch.street_code = ''
      this.areas = []
      this.streets = []
      if (code) this.fetchAreas(code)
    },
    onAreaSelect(code) {
      this.sortingSearch.street_code = ''
      this.streets = []
      if (code) this.fetchStreets(code)
    },
    handleCategoryTab() {
      this.sortingPage.page = 1
      this.fetchSorting()
    },
    handleSearch() {
      this.sortingPage.page = 1
      this.fetchSorting()
    }
  }
}
</script>

<style scoped>
.app-container { padding: 20px; background-color: #f0f2f5; min-height: 100vh; }
.search-bar { background-color: #fff; padding: 16px; border-radius: 4px; margin: 16px 0; box-shadow: 0 1px 4px rgba(0,0,0,0.06); }
.toolbar { margin: 8px 0; }
.data-table { background-color: #fff; padding: 16px; border-radius: 4px; box-shadow: 0 1px 4px rgba(0,0,0,0.06); }
.pagination-container { margin-top: 16px; text-align: right; }
</style>
